<div #balloon
     class="ui-balloon"
     [ngClass]="[color, actualSide, animation, isExpanded ? 'expanded' : '']"
     [@balloonAnimation]
     [@.disabled]="isOffScreen"
     *ngIf="isVisible && !isOffScreen">

    <div class="ui-balloon__body">
        <div class="ui-balloon__content">
            <div [innerHTML]="content"></div>
        </div>

        <div class="ui-balloon__expanded-content" *ngIf="isExpanded && expandable">
            <div [innerHTML]="expandedContent"></div>
        </div>
    </div>

    <div class="ui-balloon__arrow" [ngClass]="arrowPosition"></div>

    <div class="ui-balloon__close" *ngIf="dismissable" (click)="dismiss()">
        <i class="fa fa-times"></i>
    </div>

    <div class="ui-balloon__expand" *ngIf="expandable" (click)="toggleExpand()">
        <i class="fa fa-chevron-{{ isExpanded ? 'up' : 'down' }}"></i>
    </div>
</div>
